export default __webpack_public_path__ + "static/media/tenable.4810a5b6.svg";